export const variables = {
    seleccionesUrl: "https://suscripciones.selecciones.com.ar",
    apiUrl: "https://suscripciones.selecciones.com.ar/api",
    fsStore: 'selecciones.test.onfastspring.com/popup-selecciones',
    comidaSaludable: '5f2d86d7bb83507ba7fb8854',
    controlDePeso: '5f2d86f0bb83507ba7fb885d',
    prevencionDeDolencias: '5f2d8706bb83507ba7fb8866',
  }
  